import types from '../actions/types';
import { clearAccessToken } from '../api';

const initialState = {
  email: '',
};

const cleanableState = {
  name: '',
  lastName: '',
  lastName2: '',
  gender: '',
  birthDate: '',
  phoneNumber: '',
  cellPhoneNumber: '',
  
  addressState: null,
  addressCity: null,
  addressStreet: null,
  addressNumber: '',
  addressApto: '',
  
  occupation: null,
  documentType: '',
  documentNumber: '',

  errorMessage: '',
};

const client = (state = {...initialState, ...cleanableState}, action) => {
  switch (action.type) {

    case types.CLEAN:
      clearAccessToken();
      return { ...state, ...cleanableState};
      
    case types.SET_CLIENT_VALUE: {
      const { type, value } = action.payload;
      return {
        ...state,
        [type]: value
      }
    };

    default:
      return state;
  }
};

export default client;
